import { P0, S, abs, fillAt, max, rotPts } from '../../geometry';

export const leaf = {
  name: 'Leaf',
  colors: ['#2F9E5B', '#C46A3E'],
  draw(m, t) {
    let rot = -8 + 4 * S(t * 1.1),
      curl = 2 * S(t * 1.5),
      bud = 6 * S(t * 1.8),
      L = 1,
      pose = P0();
    if (m === 'happy') {
      rot = -8 + 12 * S(t * 6);
      bud = 22 * S(t * 9);
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: the leaf keeps rocking on its stem like a pendulum, the tip curling behind it.
    if (m === 'thinking') {
      rot = 17 * S(t * 1.8);
      curl = -8 * S(t * 1.8 - 0.8);
      bud = 20 * S(t * 3.6);
    }
    if (m === 'talking') {
      L = 1 + 0.06 * max(0, S(t * 10));
      curl = 3 * S(t * 10);
    }
    if (m === 'surprised') {
      rot = 0;
      L = 1.12;
      curl = 0;
      bud = -24;
    }
    if (m === 'paused') {
      rot = -30 + 1.5 * S(t * 0.7);
      curl = 7;
      bud = 28;
      pose.ty = 2;
    }
    const side = (sgn) =>
      [...Array(10)].map((_, k) => {
        const u = k / 9,
          hw = 23 * Math.pow(S(Math.PI * Math.pow(u, 0.8)), 0.9);
        return [50 + sgn * hw + curl * u * u * u, 72 - 56 * L * u];
      });
    const blade = rotPts(
      [...side(-1), ...side(1).reverse().slice(1)],
      50,
      74,
      rot
    );
    const stem = rotPts(
      [
        [50, 70],
        [50 + bud * 0.05, 78],
        [47 + bud * 0.12, 85],
        [42 + bud * 0.2, 89],
      ],
      50,
      74,
      rot * 0.35
    );
    const eye = rotPts([[50 + curl * 0.1, 49]], 50, 74, rot)[0];
    return {
      strokes: [
        { c: 'b', pts: stem },
        { c: 'a', pts: blade, n: 32 },
      ],
      eyes: { x: eye[0], y: eye[1] },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 1),
};
